import ApiGlobalSettings from "../@types/api/settings";
import i18n from "../i18n";

export const getLang = (): string => {
    return i18n.language.substring(0, 2).toLowerCase() || "en";
}

export const defLangs = ["SE", "EN"];

export const getLanguages = (): string[] => {
    let langs = defLangs;
    const strSettings = localStorage.getItem("settings");
    if (strSettings) {
        try {
            const settings = JSON.parse(strSettings) as ApiGlobalSettings;
            langs = settings?.availableLanguages?.map(x => x.trim().toLowerCase()) || defLangs;
        }
        catch (e) {
            // ignore
        }
    }
    return langs;
}